import {USER_INFO} from "../config/config";

// Roles de administracion superior. Segun la jerarquia documentada en
// Pages/Components/Updates/RegionDpaIdsUtils.tsx, SYSADMIN y GLOBAL_ADMIN son de
// nivel superior y REGION_ADMIN de nivel medio; el resto no administra.
export const ROLES_SUPERIORES: string[] = ['ROLE_SYSADMIN', 'ROLE_GLOBAL_ADMIN', 'ROLE_REGION_ADMIN'];

/**
 * Lista blanca: solo da acceso si el usuario tiene alguno de los roles indicados.
 * Se diferencia de hasAccess(), que es lista negra y deja pasar a cualquier rol
 * que no este explicitamente restringido.
 */
export function hasAnyRole(allowedRoles: string[]): boolean {
  try {
    const userRoles: string[] = JSON.parse(localStorage.getItem(USER_INFO) as string)?.roles || [];
    return allowedRoles.some(role => userRoles.includes(role));
  } catch {
    return false;
  }
}

export function hasAccess(restrictedRoles: string[]): boolean {
  const userRoles: string[] = JSON.parse(localStorage.getItem(USER_INFO) as string).roles;

  // Lista de todos los roles válidos del sistema
  const ROLESTOTALES: string[] = [
    "ROLE_COMMS_USER",
    "ROLE_COUNTRY_ADMIN",
    "ROLE_COUNTRY_PROCESS",
    "ROLE_GLOBAL_ADMIN",
    "ROLE_REGION_ADMIN",
    "ROLE_SYSADMIN",
    "ROLE_GUEST",
    "ROLE_USER",
    "ROLE_TRADUCTOR",
  ];

  // 1. Filtrar los roles del usuario que son válidos
  const validUserRoles = userRoles.filter(role => ROLESTOTALES.includes(role));

  // 2. Quitar los que están restringidos
  const rolesConAcceso = validUserRoles.filter(role => !restrictedRoles.includes(role));

  // 3. Si queda alguno, significa que el usuario tiene al menos un rol permitido
  return rolesConAcceso.length > 0;
}